var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistoryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.66666C16.6604 3.67775 17.7402 3.76617 18.4445 4.47052C19.25 5.27598 19.25 6.57234 19.25 9.16506V14.6651C19.25 17.2578 19.25 18.5542 18.4445 19.3596C17.6391 20.1651 16.3427 20.1651 13.75 20.1651H8.25C5.65728 20.1651 4.36091 20.1651 3.55546 19.3596C2.75 18.5542 2.75 17.2578 2.75 14.6651V9.16506C2.75 6.57234 2.75 5.27598 3.55546 4.47052C4.25981 3.76617 5.33956 3.67775 7.33333 3.66666",
    stroke: "#68D3C1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.2833L9.82143 13.75L13.75 10.0833",
    stroke: "#68D3C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 3.20834C7.33325 2.44895 7.94886 1.83334 8.70825 1.83334H13.2916C14.051 1.83334 14.6666 2.44895 14.6666 3.20834V4.12501C14.6666 4.8844 14.051 5.50001 13.2916 5.50001H8.70825C7.94886 5.50001 7.33325 4.8844 7.33325 4.12501V3.20834Z",
    stroke: "#68D3C1",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryDark);
export default __webpack_public_path__ + "static/media/OrderHistoryDark.eb3475e0f94c6dfdfbaa423a956a21aa.svg";
export { ForwardRef as ReactComponent };